import GENERIC_ERROR_MESSAGE from '../Constants';
export const parseError = (errorString) => {
    const errorMessages = [
        "Invalid Instruction",
        "Not Rent Exempt",
        "User Not Whitelisted",
       "Token Sale Not Initialized",
        "Token Sale Not Started",
       "Token Sale Funded",
       "Token Sale Amount Exceeds",
        "Token Sale Ended",
       "Amount Less Than Minimum",
        "Amount More Than Maximum",
       "Amount Exceeds Tokens Available For Sale",
       "Amount Exceeds Your Allocation"
    ];

    const errorExpressions = errorString.match(/(SOLR_ERROR_([0-9]{1,}))/g);
    
    let errorMessage = GENERIC_ERROR_MESSAGE;
    if (errorExpressions && errorExpressions.length) {
        const errorCode = parseInt(errorExpressions[0].replace('SOLR_ERROR_', ''));
        errorMessage = errorCode ? errorMessages[errorCode] : errorMessage;
    }
    return errorMessage;
};

export const uploadData = async (data) => {
  const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:5002/' : 'http://34.93.184.213:5002/'

    const rawResponse = await fetch(`${baseUrl}addWallets`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    return rawResponse
};

export const getStateFromUrl = () => {
  const stateHashMap= {
    '7d37bf74117fe24263c80139efaee83d': 'lottery',
    '44eeb809a9ccd051ba3207a1737b8f74': 'purchase',
    '0ec222583debadf20db9420c1e13a561': 'whitelist'
  }

  const _state = location.search.split('&')[0].split("=")[1];

  return stateHashMap[_state] || '';
}

export const getWalletData = async (walletAddress) => {
  // return Promise.resolve(1); //TODO: return always win for testing
 // return Promise.resolve(Math.floor(Math.random() * 3));
 const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:5002/' : 'https://34.93.184.213:5002/'
 
 return fetch(`${baseUrl}getLotteryStatus?walletAddress=${walletAddress}`, {method: 'POST', headers: {contentType: 'application/json'}, body: {}}).then(rawResponse => rawResponse.json());
}


export const updateWallet = async (walletAddress, data) => {
 const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:5002/' : 'https://34.93.184.213:5002/'
 
 return fetch(`${baseUrl}updateWallet?walletAddress=${walletAddress}`, {
   method: 'POST', 
 headers: {contentType: 'application/json'}, body: JSON.stringify(data)}).then(rawResponse => rawResponse.json());
}